const Version = {
    id: "3.0.0"
}

export default Version;